import { Box } from '@mui/material'
import styled from '@emotion/styled'

export const Container = styled(Box)`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  gap: 10px 32px;
`
